import { Routes } from 'react-router-dom'
import * as Sentry from '@sentry/react'

export const PortalRoutes = Sentry.withSentryReactRouterV6Routing(Routes)
